<template>
  <div class="details">
    <div class="top" @click="back"></div>
    <div class="content">
      <div class="img" v-if="param == '1.1'"><img src="../assets/compressorDetails/图片1-1.png" alt="" /></div>
      <div class="img" v-else-if="param == '1.2'"><img src="../assets/compressorDetails/图片1-2.png" alt="" /></div>
      <div class="img" v-else-if="param == '1.3'"><img src="../assets/compressorDetails/图片1-3.png" alt="" /></div>
      <div class="img" v-else-if="param == '1.4'"><img src="../assets/compressorDetails/图片1-4.png" alt="" /></div>

      <div class="img" v-else-if="param == '2.1'"><img src="../assets/compressorDetails/图片2-1.png" alt="" /></div>
      <div class="imgs" v-else-if="param == '2.2'"><img src="../assets/compressorDetails/图片2-2.png" alt="" /></div>
      <div class="imgs" v-else-if="param == '2.3'"><img src="../assets/compressorDetails/图片2-3.png" alt="" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Details",
  components: {},
  data() {
    return {
      param: ''
    };
  },
  mounted() {},
  methods: {
    back() {
      if (this.param == 1.1 || this.param == 1.2 || this.param == 1.3 || this.param == 1.4) {
        this.$router.push({
          path: "/hydrogenCompressor",
        });
      } else {
        this.$router.push({
          path: "/cngCompressor",
        });
      }
    },
  },
  created() {
    this.param = this.$route.query.id;
  },
};
</script>

<style scoped>
.top {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  background-image: url(../assets/back.png);
}
.top:hover {
  background-image: url(../assets/backHover.png);
}

.details {
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  /* height: 100vh; */
  padding: 20px;
  box-sizing: border-box;
  background-image: url(../assets/bg2.png);
}
.content {
  display: flex;
  height:calc(100vh - 40px);
  justify-content: center;
  align-items: center;
}
.content .img {
  width: 60%;
  height: auto;
}
.content .imgs {
  width:90%;
  height: auto;
}
.content .img img ,.imgs img{
  width: 100%;
  height: 100%;
}
</style>
